import { type Action, type ActionCreator } from '@ngrx/store';

export const isAction = <T extends string, AC extends ActionCreator<T, (...args: any[]) => any>>(
  action: { type: string },
  actionCreator: AC,
): action is ReturnType<AC> & Action<T> => action.type === actionCreator.type;
